module.exports = __webpack_public_path__ + "static/media/Moniviestin_logo.77631faa.svg";